import React from 'react';

import { Badge } from 'apps/auth/components/common/Badge/Badge';
import { Icon } from 'apps/auth/components/common/Icon/Icon';
import { Separator } from 'apps/auth/components/common/Layout/Separator';
import { Panel } from 'apps/auth/components/common/Panel/Panel';
import { IconWrapper, PanelContent, PanelFrame, PanelRightBlock } from 'apps/auth/components/common/Panel/styles';
import { Text } from 'apps/auth/components/common/Text/Text';
import { AUTH_GA_CARD } from 'apps/auth/constants/UrlConstants';
import { useExtra, usePageMessages } from 'apps/auth/hooks/selectors';

const LibrePocketCardList = () => {
    const { virtualCard } = useExtra();
    const { virtual, expired, linkedCard } = usePageMessages();

    if (virtualCard) {
        return (
            <>
                <Text variant="div" size="subheader" indent="16px" color="secondary">
                    {linkedCard}
                </Text>
                <Panel type="reactLink" to={`${AUTH_GA_CARD}${virtualCard?.id}`} hasIcon isHoverable negativeMargin>
                    <PanelFrame>
                        <IconWrapper>
                            <Icon name="cardp" color={virtualCard.expired ? 'superLightGray' : 'primary'} />
                        </IconWrapper>
                        <PanelContent>
                            <Text color={virtualCard.expired ? 'lightGray' : 'primary'}>{`${virtual} ${virtualCard.panGroupLast6Digits}`}</Text>
                        </PanelContent>
                        {virtualCard.expired && (
                            <PanelRightBlock>
                                <Badge caption={expired} size="fit" variant="tertiary" />
                            </PanelRightBlock>
                        )}
                    </PanelFrame>
                </Panel>
                <Separator marginTop="16px" />
            </>
        );
    }
    return <></>;
};
export default LibrePocketCardList;
